import React from 'react';
import { Button } from 'reactstrap';
import './BtnBand.css';
import CBand from './../images/CBand.png';
import KuBD from './../images/Ku_BD.png';
import KuIndia from './../images/Ku_India.png';
import KuIndonesia from './../images/Ku_Indonesia.png';
import KuPhilippines from './../images/Ku_Philippines.png';
class BtnBand extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedButton: ''
    }

    this.satSource = {
      'C-band': {
        'latLng': [90.399452, 23.777176],
        'name': 'CBand'
      },
      'Ku-band Bangladesh': {
        'latLng': [90.399452, 23.777176],
        'name': 'BDBand'
      },
      'Ku-band India Plus': {
        'latLng': [78.8718, 21.7679],
        'name': 'IndiaBand'
      },
      'Ku-band Indonesia': {
        'latLng': [114.590111, -3.316694],
        'name': 'IndoBand'
      },
      'Ku-band Philippines': {
        'latLng': [122.64194, 11.10778],
        'name': 'PhBand'
      },

    }

    this.satellites = [
      {
        name: 'C-band',
        src: CBand
      },
      {
        name: 'Ku-band Bangladesh',
        src: KuBD
      },
      {
        name: 'Ku-band India Plus',
        src: KuIndia
      },
      {
        name: 'Ku-band Indonesia',
        src: KuIndonesia
      },
      {
        name: 'Ku-band Philippines',
        src: KuPhilippines
      }
    ]
  }

  coverageChange (satteliteName) {
    this.setState({ selectedButton: satteliteName })
    this.props.onChangeBand(
      this.satSource[satteliteName].latLng,
      this.satSource[satteliteName].name
    )
  }

  buttonCoverage = () => {
    return this.satellites.map(satellite =>
      (
        <Button 
          className={"BtnBand-button " + (satellite['name'] === this.state.selectedButton ? 'selected' : '') }
          key={satellite['name']}
          onClick={() => this.coverageChange(satellite['name'])}
        >
          <img alt={satellite['name']} className="BtnBand-img-sattelite" src={satellite['src']} />
          <p>{satellite['name']}</p>
        </Button>
      )
    )
  }

  render(){
    return (
      <div className="BtnBand-panel">
        <div className="BtnBand-header">
          <b>Coverage</b>
        </div>
        <div className="BtnBand-container">
          {this.buttonCoverage()}
        </div>
      </div>
    );
  }
}

export default BtnBand;